import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { persistQueryClient } from '@tanstack/react-query-persist-client';
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister';
interface Props {
  children: React.ReactNode;
}

function makeQueryClient() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60,
        gcTime: 1000 * 60 * 5, // 5 minutes
      },
    },
  });

  // Create a storage persister
  const persister = createSyncStoragePersister({
    storage: window.localStorage,
  });

  // Persist the query cache
  persistQueryClient({
    queryClient,
    persister,
    dehydrateOptions: {
      shouldDehydrateQuery: (query) => {
        return query.state.status === 'success' && query.meta?.['persist'] !== false;
      },
    },
    maxAge: 1000 * 60 * 5, // 5 minutes
  });

  return queryClient;
}

let browserQueryClient: QueryClient | undefined = undefined;
function getQueryClient() {
  if (!browserQueryClient) browserQueryClient = makeQueryClient();
  return browserQueryClient;
}

export default function QueryProvider({ children }: Props) {
  const queryClient = getQueryClient();
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
}
